import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { company } from "../data/site";

export default function FloatingActions() {
  const wa = `https://wa.me/${company.whatsapp}?text=${encodeURIComponent(
    "Hello Hoflich, I'd like a building approval consultation."
  )}`;
  const tel = `tel:${company.phone.replace(/\s/g, "")}`;

  return (
    <div className="fixed bottom-5 right-5 md:bottom-7 md:right-7 z-40 flex flex-col gap-3">
      {/* Call */}
      <motion.a
        href={tel}
        data-testid="floating-call"
        aria-label="Call Hoflich"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1.6, type: "spring", stiffness: 220, damping: 16 }}
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.95 }}
        className="group relative grid place-items-center h-12 w-12 md:h-14 md:w-14 rounded-full bg-[#C96A2B] text-white shadow-[0_12px_40px_-10px_rgba(201,106,43,0.7)] border border-white/10"
      >
        <span
          className="absolute inset-0 rounded-full"
          style={{
            animation: "pulseRing 2.4s ease-out infinite",
            background: "rgba(201,106,43,0.5)",
            zIndex: -1,
          }}
        />
        <Phone size={20} />
        <span className="pointer-events-none absolute right-[calc(100%+10px)] top-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-[#080808] border border-white/10 px-3 py-1.5 text-xs opacity-0 group-hover:opacity-100 transition-opacity">
          {company.phone}
        </span>
      </motion.a>

      {/* WhatsApp */}
      <motion.a
        href={wa}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp"
        aria-label="Chat on WhatsApp"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1.4, type: "spring", stiffness: 220, damping: 16 }}
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.95 }}
        className="wa-pulse group relative grid place-items-center h-12 w-12 md:h-14 md:w-14 rounded-full bg-[#25D366] text-black shadow-[0_12px_40px_-10px_rgba(37,211,102,0.6)] border border-white/10"
      >
        <svg viewBox="0 0 32 32" width="22" height="22" fill="currentColor" aria-hidden="true">
          <path d="M19.11 17.21c-.3-.15-1.78-.88-2.05-.98-.27-.1-.47-.15-.66.15-.2.3-.76.97-.93 1.17-.17.2-.34.22-.64.08-.3-.15-1.27-.47-2.42-1.5-.9-.8-1.5-1.79-1.67-2.09-.17-.3-.02-.46.13-.61.13-.13.3-.34.45-.51.15-.17.2-.29.3-.49.1-.2.05-.37-.02-.52-.08-.15-.66-1.6-.91-2.19-.24-.58-.49-.5-.66-.51l-.56-.01c-.2 0-.51.07-.78.37-.27.3-1.03 1-1.03 2.45 0 1.45 1.05 2.85 1.2 3.05.15.2 2.07 3.17 5.02 4.45.7.3 1.25.48 1.68.62.7.22 1.34.19 1.85.12.56-.08 1.78-.73 2.03-1.43.25-.7.25-1.3.17-1.43-.07-.13-.27-.21-.57-.36zM16.04 6C10.55 6 6.08 10.47 6.08 15.96c0 1.76.46 3.48 1.34 4.99L6 26l5.21-1.37a9.95 9.95 0 0 0 4.83 1.23h.01c5.49 0 9.96-4.47 9.96-9.96A9.95 9.95 0 0 0 16.04 6z" />
        </svg>
        <span className="pointer-events-none absolute right-[calc(100%+10px)] top-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-[#080808] border border-white/10 px-3 py-1.5 text-xs opacity-0 group-hover:opacity-100 transition-opacity text-white">
          Chat on WhatsApp
        </span>
      </motion.a>
    </div>
  );
}
